import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import BodyTypeTabsUI from './BodyTypeTabsUI';
import { ACURA_SITE_NAME, HONDA_SITE_NAME, PE_SITE_NAME, PSP_SITE_NAME } from '../../../utils/constants';
import { ModelFiltersContext } from '../../ModelFiltersContext';
import { getFilterableComponentsFromSitecoreRoute, getModelDataFromSitecoreRoute, getModelListFiltersFieldsDataFromSitecoreRoute, getModelNamesFromFieldsData, getModelNamesFromModelData, isCategoryHasProducts, } from '../service/utils';
import { useAppName, useRoute } from '../../../utils/sitecoreContext';
const BodyTypeTabs = ({ allItemsLabel }) => {
    var _a, _b;
    const { allBodyTypes } = useContext(ModelFiltersContext) || {};
    const appName = useAppName();
    const route = useRoute();
    const modelData = getModelDataFromSitecoreRoute(route, appName);
    const modelNames = getModelNamesFromModelData(modelData);
    // format modelName array to key value pairs
    const formattedModelName = (_a = modelNames === null || modelNames === void 0 ? void 0 : modelNames.filter(item => !!item)) === null || _a === void 0 ? void 0 : _a.map(item => ({ key: item, value: item }));
    const fields = getModelListFiltersFieldsDataFromSitecoreRoute(route);
    const modelNamesFromFieldsData = getModelNamesFromFieldsData(fields);
    const formattedModelNamesFromFieldsData = (_b = modelNamesFromFieldsData === null || modelNamesFromFieldsData === void 0 ? void 0 : modelNamesFromFieldsData.filter(item => isCategoryHasProducts(modelData, item.modelName))) === null || _b === void 0 ? void 0 : _b.map(item => ({
        key: item.modelName,
        value: item.displayName,
    }));
    let bodyTypes;
    let showFutureVehicle;
    let dispatchType;
    let hasReducedSpacing;
    let canShowArrows = false;
    let splideItemsNumber = 6;
    switch (appName) {
        case HONDA_SITE_NAME:
        case ACURA_SITE_NAME:
            bodyTypes = allBodyTypes;
            showFutureVehicle = getFilterableComponentsFromSitecoreRoute(route, 'FutureVehicleCard');
            dispatchType = 'bodyType';
            hasReducedSpacing = true;
            break;
        case PSP_SITE_NAME:
            bodyTypes = formattedModelName;
            dispatchType = 'model';
            canShowArrows = true;
            hasReducedSpacing = true;
            break;
        case PE_SITE_NAME:
            bodyTypes = formattedModelNamesFromFieldsData;
            dispatchType = 'model';
            canShowArrows = true;
            hasReducedSpacing = true;
            splideItemsNumber = 4;
            break;
        default:
            return null;
    }
    return (_jsx(BodyTypeTabsUI, { bodyTypes: bodyTypes, showFutureVehicle: showFutureVehicle, dispatchType: dispatchType, hasReducedSpacing: hasReducedSpacing, splideItemsNumber: splideItemsNumber, allItemsLabel: allItemsLabel, canShowArrows: canShowArrows }));
};
export default BodyTypeTabs;
